import React, { useEffect, useState } from "react";
import { get } from "lodash";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-light-svg-icons";
import { getPathWithParam } from "../../utils";
import tenantConfig from "../../mocks/tenantOne.json";
import authorization from "../../mocks/menuPermissions.json";
import authService from "../api-authorization/AuthorizeService";
import { faDiamond } from "@fortawesome/pro-solid-svg-icons";
const ManageFeeMenu = ({ menuList = [], selectedMenu }) => {
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  return (
    <>
      <h5 className="fw-600 p-1 ml-4 mt-3">Fee</h5>
      <ul className="manage-company-menu">
        {menuList.map((item) => {
          const childRoutes = get(item, "childRoutes", []);
          let className =
            selectedMenu.indexOf(item.path) !== -1 ||
            childRoutes.filter((route) => {
              return selectedMenu.indexOf(route) !== -1;
            }).length
              ? "selected"
              : "";
          let iconClassName =
            className === "selected" ? "mr-3 blue-diamond-icon" : "mr-3";
          return (
            tenantConfig.feeSubMenu.includes(item.id) &&
            authorization[roleName].feeSubMenu[item.id] && (
              <li key={item.path} className={`${className} mt-3`}>
                <FontAwesomeIcon
                  className={iconClassName}
                  icon={faDiamond}
                  size="sm"
                />
                <Link
                  to={getPathWithParam({
                    path: item.path,
                  })}
                >
                  {item.label}
                </Link>
              </li>
            )
          );
        })}
      </ul>
    </>
  );
};

export default ManageFeeMenu;
